import { Component } from '@angular/core';
import { Tag } from 'primeng/tag';

import { AppService } from '@/service/app.service';

@Component({
    selector: 'app-environment-badge',
    standalone: true,
    imports: [Tag],
    template: `
        @if (visible) {
            <p-tag [rounded]="true" [severity]="severity">
                {{ label }}
            </p-tag>
        }
    `,
    styles: [`
        :host {
            display: inline-flex;
            align-items: center;
        }
    `]
})
export class AppEnvironmentBadge {
    constructor(private appService: AppService) {}

    get visible(): boolean {
        return this.appService.environment.env !== 'production';
    }

    get label(): string {
        switch (this.appService.environment.env) {
            case 'local':
                return 'Local';
            case 'dev':
                return 'Dev';
            default:
                return this.appService.environment.env;
        }
    }

    get severity(): 'info' | 'warn' | 'secondary' {
        switch (this.appService.environment.env) {
            case 'local':
                return 'info';
            case 'dev':
                return 'warn';
            default:
                return 'secondary';
        }
    }
}
